import React, { useEffect } from 'react';
import { Loader } from '../../core/components';
import { useAuthenticationContext } from '../../core/services/AuthenticationProvider';

const LogoutRoute = () => {
  const authContext = useAuthenticationContext();

  useEffect(() => {
    if(authContext && authContext.logout){
      authContext.logout();
    }
  },[]);

  return (
    <Loader main={true} opacity={1} />
  );
};

export default LogoutRoute;
